import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ViewEncapsulation, Input } from '@angular/core';
import { BarTileWidgetsService } from './bar-tile-widget.service';
declare var pg: any;
declare var echarts: any;

@Component({
  selector: 'bar-tile-widget',
  templateUrl: './bar-tile-widget.component.html',
  styleUrls: ['./bar-tile-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class BarTileWidgetComponent implements OnInit,OnDestroy {
  chartOptions;
  timeout;
  chartData = [
    // {
    //   "key": "Base Salario",
    //   "values": [ [0, 58042500 ] ],
    // },
    // {
    // "key": "Prestaciones",
    // "values": [[0, 8000500]],
    // },
    // {
    //   "key": "Seguridad Social",
    //   "values": [[0, 1602500]],
    //   }
]

@Input() typeChart = "multiBarChart" ;
@Input() AdditionalColorCard = "transparent" ;
@Input() title = "" ;
@Input() detail = "" ;
@Input() functionData = "unknow" ;

 value = "" ; // valor acumulado
 unicoValor = true ;
 keyUnicoValor = this.title ;
 totalValue = 0; // limite  maximo  de valores  utilizado en la grafica

 query; // sentencia query para obtener datos
 loading = false;

 constructor( private barTileWidgetsService: BarTileWidgetsService) {

 }

 ngOnInit() {
  this.loading = true;
  this.barTileWidgetsService.getFunctionByName(this.functionData)
  .toPromise().then( (res: any ) => { this.query = res.query; } )
  .then( () => {this.getData(); })
  .catch ( err => {
    this.loading = false;
    console.log(err);
  } );
}

getData() {
  this.loading = true;
  const args = { param: {}, query: this.query };
  this.barTileWidgetsService.getData(args).toPromise()
  .then (async (res: any) => {
      // console.log('costo' , res)
      let arrRes = res;
      if (this.unicoValor) {
        arrRes = [[this.keyUnicoValor , res[0] ]];
      }
      // console.log('resultado' , arrRes)
      await this.buildArrData(arrRes);
      this.loading = false;
  })
  .catch ( err => {
    console.log(err);
    this.loading = false;
  } );
}

buildArrData( arrOriginal: any[]) {

  console.log('valor recibido' , arrOriginal)
  return new Promise (resolve => {
    let total = 0;
    let mayorValue = 0 ;
    let mayorKey = '' ;
    this.chartData = arrOriginal.map (item => {
      // acumular valores e identificar mayor key y valor
      total += item[1] ;
      if (item[1] > mayorValue) {
        mayorKey = item[0] ;
        mayorValue = item[1];
      }
      return  {key : item[0] , values : [[0, item[1]]] };
    } );

    console.log('valor Bar char',this.chartData)
    // this._detail = `${mayorValue} de ${total.toString()}${this.detail}`;
    this.value = (total).toFixed(2).toString();
    this.totalValue = (total * 1.15) ; // incremento 15% mas al valor
    // this._title = `${this.title}${mayorKey}`;
    resolve(); // condicion para indicar que la promesa termino, sino se envia queda en espera
  });
  }

  ngOnDestroy(){
    clearTimeout(this.timeout)
  }
  ngAfterViewInit() {
    this.timeout = setTimeout(()=>{
      this.chartOptions = {
        chart: {
          type:  this.typeChart, // 'multiBarHorizontalChart' , // multiBarChart
          // color: [
          //   pg.getColor('danger'),
          //   pg.getColor('master-light')
          // ],
          x: function (d) { return d[0]; },
          y: function (d) { return d[1]; },
          multibar:{
            stacked:true
          },
          showControls:false,
          useInteractiveGuideline: false,
          tooltip:{
            enabled:true
          },
          margin: {
            top: 0,
            right:0,
            bottom:0,
            left:0
          },
          groupSpacing:0.7,
          yDomain:[0,this.totalValue],
          showLegend: false,          
          showXAxis:false,
          showYAxis:false,
          interactive:false
        }
      }
    },2000);
  }

}